import { observer } from 'mobx-react'
import BaseUserImage from '@images/BotAV.svg'
import { CSSProperties, FC, ReactNode } from 'react'

interface AvatarProps {
	height?: number
	width?: number
	style?: CSSProperties
	children?: ReactNode
	src?: string
}

export const ProfileAvatar: FC<AvatarProps> = observer(
	({ height = 102, width = 102, style, children, src }) => {
		console.log(src)

		const isCustomImage = !!src

		return (
			<div
				style={{
					position: 'relative',
					width,
					height,
					padding: 4,
					backgroundColor: '#f1f1f1',
					borderRadius: 9999,
					...style,
				}}>
				<div
					style={{
						justifyContent: 'center',
						display: 'flex',
						alignItems: 'center',
						width: '100%',
						height: '100%',
						backgroundColor: isCustomImage ? 'transparent' : 'white',
						borderRadius: '50%',
						overflow: 'hidden',
					}}>
					{isCustomImage ? (
						<img
							src={src}
							alt='Фотография пользователя'
							width='100%'
							height='100%'
							style={{
								objectFit: 'cover',
								width: width,
								height: height,
								borderRadius: '50%',
							}}
						/>
					) : (
						<img
							src={BaseUserImage}
							alt='Фотография по-умолчанию'
							width={height * 0.6}
							height={width * 0.6}
							style={{ marginTop: -5 }}
						/>
					)}
				</div>
				<div style={{ position: 'absolute', bottom: 0, right: 0 }}>{children}</div>
			</div>
		)
	}
)
